import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("pending");

  useEffect(() => {
    if (!sessionId) return undefined;
    let tries = 0;
    const t = setInterval(async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          localStorage.removeItem("sweetjuice_cart_v2");
          clearInterval(t);
        } else if (tries > 10) {
          setState("timeout");
          clearInterval(t);
        }
      } catch {
        if (tries > 10) {
          setState("timeout");
          clearInterval(t);
        }
      }
    }, 2500);
    return () => clearInterval(t);
  }, [sessionId]);

  return (
    <main data-testid="payment-success-page" className="min-h-screen bg-[#E5A910] grid place-items-center px-5">
      <div className="bg-[#FFF4D6] rounded-3xl p-10 max-w-md text-center">
        {state === "pending" && <Loader2 className="w-12 h-12 mx-auto animate-spin" />}
        {state === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-[#2E7D32]" />
            <h1 className="font-display text-3xl font-extrabold mt-4">Payment received!</h1>
            <p className="mt-2 text-[#594519]">Your juice is confirmed. We'll text you the delivery quote or pickup details.</p>
          </>
        )}
        {state === "timeout" && (
          <>
            <XCircle className="w-14 h-14 mx-auto text-[#B5122F]" />
            <h1 className="font-display text-3xl font-extrabold mt-4">Still confirming…</h1>
            <p className="mt-2 text-[#594519]">Your payment is processing. Refresh in a moment or contact us.</p>
          </>
        )}
        <Link to="/" data-testid="payment-home-link" className="mt-6 inline-flex h-12 items-center rounded-full bg-[#181203] text-[#FFD000] font-bold px-6">Back to home</Link>
      </div>
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="min-h-screen bg-[#E5A910] grid place-items-center px-5">
      <div className="bg-[#FFF4D6] rounded-3xl p-10 max-w-md text-center">
        <XCircle className="w-14 h-14 mx-auto text-[#B5122F]" />
        <h1 className="font-display text-3xl font-extrabold mt-4">Payment cancelled</h1>
        <p className="mt-2 text-[#594519]">No charge was made. Your cart is saved whenever you're ready.</p>
        <Link to="/shop" data-testid="payment-shop-link" className="mt-6 inline-flex h-12 items-center rounded-full bg-[#181203] text-[#FFD000] font-bold px-6">Back to shop</Link>
      </div>
    </main>
  );
}
